import styled, { css } from 'styled-components';

import LoyaltyRewardsLogo from 'components/icons/loyalty-rewards-logo-simple';

import {
  CTAWrapper as CTAWrapperStyled,
  Balance as DefaultBalance,
  PointBalancePointsIcon as DefaultPointBalancePointsIcon,
  PointText as DefaultPointText,
  GreetingWrapper as GreetingWrapperStyled,
  PointsWrapper as PointsWrapperStyled,
} from './loyalty-cta-bar.styled.default';

export * from './loyalty-cta-bar.styled.default';

export const Balance = styled(DefaultBalance)`
  border: 0.0625rem solid ${Styles.color.white};
  border-radius: 1rem;
  padding: 0.25rem 0.375rem;
  div {
    display: flex;
    margin-inline-end: 0.25rem;
  }
`;

export const PointText = styled(DefaultPointText)`
  margin-inline-end: 1rem;
`;

const horizontalPadding = css`
  padding: 0 0.5rem;
`;

export const PointBalancePointsIcon = styled(DefaultPointBalancePointsIcon)`
  margin: 0 0.31rem;
  height: 1rem;
  path {
    fill: ${Styles.color.white};
  }
`;

export const PointsWrapper = styled(PointsWrapperStyled)`
  ${horizontalPadding};
  order: 2;
  svg {
    width: 5rem;
  }
`;

export const GreetingWrapper = styled(GreetingWrapperStyled)`
  ${horizontalPadding};
  order: 1;
  justify-content: flex-start;
`;

export const CTAWrapper = styled(CTAWrapperStyled)`
  ${horizontalPadding};
  justify-content: space-between;
`;

export const StyledLoyaltyRewardsLogo = styled(LoyaltyRewardsLogo)`
  margin-inline-end: 0.625rem;
  path {
    fill: ${Styles.color.white};
  }
`;
